import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PrivacyPolicyPage, TermsOfUsePage } from '../constants';

interface AuthLayoutProps {
    children: React.ReactNode;
    leftPanel?: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, leftPanel }) => {
    const currentYear = new Date().getFullYear();
    const location = useLocation();
    const legalLinkState = {
        returnTo: `${location.pathname}${location.search}`,
    };

    return (
        <div className="force-light flex min-h-screen w-full bg-background text-foreground">
            {/* Left side - Floating Dark Blue Block */}
            <div className="hidden w-1/2 items-center justify-center p-4 md:flex md:w-1/2">
                <div className="relative flex size-full flex-col items-center justify-center overflow-hidden rounded-3xl bg-primary">
                    {leftPanel || (
                        <>
                            {/* Optional: Add abstract shapes or subtle gradient here if needed to match image exactly. */}
                        </>
                    )}
                </div>
            </div>

            {/* Right side - Form */}
            <div className="flex w-full flex-col px-8 md:w-1/2 md:px-24">
                <div className="flex flex-1 flex-col justify-center">{children}</div>

                <div className="flex flex-col items-center justify-between gap-3 py-6 text-center text-xs font-medium text-muted-foreground sm:flex-row sm:text-left">
                    <span className="flex flex-wrap justify-center gap-x-4 gap-y-1 sm:justify-start">
                        <Link
                            to={`/${TermsOfUsePage}`}
                            state={legalLinkState}
                            className="transition-colors hover:text-foreground hover:underline"
                        >
                            Termos de uso
                        </Link>
                        <Link
                            to={`/${PrivacyPolicyPage}`}
                            state={legalLinkState}
                            className="transition-colors hover:text-foreground hover:underline"
                        >
                            Política de privacidade
                        </Link>
                    </span>
                    <span className="whitespace-nowrap">Copyright {currentYear} LaudoPsi</span>
                </div>
            </div>
        </div>
    );
};

export default AuthLayout;
